export default __webpack_public_path__ + "static/media/OpenSans-BoldItalic.e60eebe7.ttf";